import { useMutation } from "@bb-vendure/admin-ui/react";
import { gql } from "graphql-tag";

const DELETE_SPEC = gql`
  mutation DeleteSpec($id: ID!) {
    deleteProductSpecification(id: $id) {
      message
    }
  }
`;

export default function useDeleteSpec<T>() {
  return useMutation<T>(DELETE_SPEC);
}
